import { render, staticRenderFns } from "./StatisticsRow.vue?vue&type=template&id=397a1c4e&scoped=true&"
import script from "./StatisticsRow.vue?vue&type=script&lang=js&"
export * from "./StatisticsRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397a1c4e",
  null
  
)

export default component.exports